function openMailForm() {
    $("#sendEmail").modal();
}
function openMailRegularForm() {
    $("#sendEmailRegular").modal();
}